"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.formatOperation = exports.formatAccount = exports.accountFormatters = void 0;
var invariant_1 = __importDefault(require("invariant"));
var bignumber_js_1 = require("bignumber.js");
var _1 = require(".");
var operation_1 = require("../operation");
var currencies_1 = require("../currencies");
var operation_2 = require("../operation");
var derivation_1 = require("../derivation");
var account_1 = __importDefault(require("../generated/account"));
var nft_1 = require("../nft");
var styling = {
    bold: function (str) { return "\u001B[1m".concat(str, "\u001B[22m"); },
    underline: function (str) { return "\u001B[4m".concat(str, "\u001B[24m"); },
    cyan: function (str) { return "\u001B[36m".concat(str, "\u001B[37m"); },
    magenta: function (str) { return "\u001B[35m".concat(str, "\u001B[37m"); },
    reverse: function (str) { return "\u001B[7m".concat(str, "\u001B[27m"); }
};
var isSignificantAccount = function (acc) {
    return acc.balance.gt(Math.pow(10, ((0, _1.getAccountUnit)(acc).magnitude - 6)));
};
var formatOp = function (unitByAccountId, familySpecific) {
    var format = function (op, level) {
        if (level === void 0) { level = 0; }
        var unit = unitByAccountId(op.accountId);
        var amountBN = (0, operation_2.getOperationAmountNumber)(op);
        var amount = unit
            ? (0, currencies_1.formatCurrencyUnit)(unit, amountBN, {
                showCode: true,
                alwaysShowSign: true,
                disableRounding: true
            })
            : "? " + amountBN.toString();
        var spaces = Array((level + 1) * 2)
            .fill(" ")
            .join("");
        var extra = level > 0
            ? ""
            : "".concat(op.hash, " ").concat(op.date
                .toISOString()
                .split(":")
                .slice(0, 2)
                .join(":"));
        extra += familySpecific(op, unit);
        var head = "".concat((spaces + amount).padEnd(20), " ").concat(((op.hasFailed ? "❌" : "") + op.type).padEnd(11)).concat(extra);
        var sub = (op.subOperations || [])
            .concat(op.internalOperations || [])
            .map(function (subop) { return format(subop, level + 1); })
            .join("");
        return "\n".concat(head).concat(sub);
    };
    return function (op) { return format(op, 0); };
};
function maybeDisplaySumOfOpsIssue(ops, balance, unit) {
    var sumOfOps = ops.reduce(function (sum, op) { return sum.plus((0, operation_2.getOperationAmountNumber)(op)); }, new bignumber_js_1.BigNumber(0));
    if (sumOfOps.eq(balance))
        return "";
    return (" (! sum of ops " +
        (0, currencies_1.formatCurrencyUnit)(unit, sumOfOps, {
            showCode: true,
            disableRounding: true
        }) +
        ")");
}
var cliFormat = function (account, level) {
    var id = account.id, name = account.name, freshAddress = account.freshAddress, freshAddressPath = account.freshAddressPath, derivationMode = account.derivationMode, index = account.index, operations = account.operations, nfts = account.nfts;
    var tag = (0, derivation_1.getTagDerivationMode)(account.currency, derivationMode);
    var balance = (0, currencies_1.formatCurrencyUnit)(account.unit, account.balance, {
        showCode: true
    });
    var opsCount = "".concat(operations.length, "ops");
    var freshInfo = "".concat(freshAddress, " on ").concat(freshAddressPath);
    var derivationInfo = "".concat(derivationMode, "#").concat(index);
    var str = "".concat(name).concat(tag ? " [" + tag + "]" : "", ": ").concat(balance, " (").concat(opsCount, ") (").concat(freshInfo, ") ").concat(derivationInfo, " ").concat(id || "");
    if (level === "head")
        return str;
    str += maybeDisplaySumOfOpsIssue(operations, account.balance, (0, _1.getAccountUnit)(account));
    var family = account_1["default"][account.currency.family];
    if (family && family.formatAccountSpecifics) {
        str += family.formatAccountSpecifics(account);
        str += "\n";
    }
    var subAccounts = account.subAccounts || [];
    str += subAccounts
        .map(function (ta) {
        return "  " +
            ta.type +
            " " +
            (0, _1.getAccountName)(ta) +
            ": " +
            (0, currencies_1.formatCurrencyUnit)((0, _1.getAccountUnit)(ta), ta.balance, {
                showCode: true,
                disableRounding: true
            }) +
            " (" +
            ta.operations.length +
            " ops)" +
            maybeDisplaySumOfOpsIssue(ta.operations, ta.balance, (0, _1.getAccountUnit)(ta));
    })
        .join("\n");
    if (nfts === null || nfts === void 0 ? void 0 : nfts.length) {
        var NFTCollections = (0, nft_1.nftsByCollections)(nfts);
        str += "\n";
        str += "NFT Collections (".concat(NFTCollections.length, ") ");
        str += "\n";
        str += NFTCollections.map(
        // nfts are set to any because there not just NFT, we added a metadata prop on the fly
        // in the first step of the Rxjs flow to avoid having some async code here
        function (_a) {
            var _b, _c;
            var contract = _a.contract, nfts = _a.nfts;
            var tokenName = (_c = (_b = nfts === null || nfts === void 0 ? void 0 : nfts[0]) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.tokenName;
            var bold = styling.bold, magenta = styling.magenta, cyan = styling.cyan, reverse = styling.reverse;
            return ("".concat(bold(tokenName !== null && tokenName !== void 0 ? tokenName : "Unknown Collection Name"), " (").concat(magenta(contract), "): ") +
                nfts
                    .map(function (t) {
                    var _a, _b;
                    return ((_a = t === null || t === void 0 ? void 0 : t.metadata) === null || _a === void 0 ? void 0 : _a.nftName)
                        ? "\n  ".concat(t.amount, "x ").concat(reverse(" ".concat((_b = t === null || t === void 0 ? void 0 : t.metadata) === null || _b === void 0 ? void 0 : _b.nftName, " ")), " ").concat(cyan("#" + t.tokenId))
                        : "\n  ".concat(t.amount, "x ").concat(cyan("#" + t.tokenId));
                })
                    .join());
        }).join("\n");
    }
    if (level === "basic")
        return str;
    str += "\nOPERATIONS (" + operations.length + ")";
    str += operations
        .map(formatOp(function (id) {
        if (account.id === id)
            return account.unit;
        var ta = subAccounts.find(function (a) { return a.id === id; });
        if (ta)
            return (0, _1.getAccountUnit)(ta);
        console.error("unexpected missing token account " + id);
    }, function (operation, unit) {
        if (family && family.formatOperationSpecifics) {
            return family.formatOperationSpecifics(operation, unit);
        }
        return "";
    }))
        .join("");
    return str;
};
var stats = function (account) {
    var subAccounts = account.subAccounts, operations = account.operations;
    var sumOfAllOpsNumber = operations.reduce(function (sum, op) { return sum.plus((0, operation_1.getOperationAmountNumberWithInternals)(op)); }, new bignumber_js_1.BigNumber(0));
    var sumOfAllOps = (0, currencies_1.formatCurrencyUnit)(account.unit, sumOfAllOpsNumber, {
        showCode: true
    });
    var balance = (0, currencies_1.formatCurrencyUnit)(account.unit, account.balance, {
        showCode: true
    });
    return {
        balance: balance,
        sumOfAllOps: sumOfAllOps,
        opsCount: operations.length,
        subAccountsCount: (subAccounts || []).length
    };
};
// this is developped for debug purpose in order to compare with balance APIs
var operationBalanceHistoryBackwards = function (account) {
    var acc = account.balance;
    return JSON.stringify(account.operations
        .map(function (op) {
        var blockHeight = op.blockHeight;
        var date = op.date.toISOString();
        var balance = acc.toNumber();
        acc = acc.minus((0, operation_1.getOperationAmountNumberWithInternals)(op));
        return { blockHeight: blockHeight, date: date, balance: balance };
    })
        .reverse());
};
var operationBalanceHistory = function (account) {
    var acc = new bignumber_js_1.BigNumber(0);
    return JSON.stringify(account.operations
        .slice(0)
        .reverse()
        .map(function (op) {
        acc = acc.plus((0, operation_1.getOperationAmountNumberWithInternals)(op));
        var blockHeight = op.blockHeight;
        var date = op.date.toISOString();
        var balance = acc.toNumber();
        return { blockHeight: blockHeight, date: date, balance: balance };
    }));
};
exports.accountFormatters = {
    operationBalanceHistoryBackwards: operationBalanceHistoryBackwards,
    operationBalanceHistory: operationBalanceHistory,
    json: function (account) { return JSON.stringify((0, _1.toAccountRaw)(account)); },
    head: function (account) { return cliFormat(account, "head"); },
    "default": function (account) { return cliFormat(account); },
    basic: function (account) { return cliFormat(account, "basic"); },
    full: function (account) { return cliFormat(account, "full"); },
    stats: function (account) { return stats(account); },
    significantTokenTickers: function (account) {
        return (account.subAccounts || [])
            .filter(isSignificantAccount)
            .map(function (ta) { return (0, _1.getAccountCurrency)(ta).ticker; })
            .join("\n");
    }
};
function formatAccount(account, format) {
    if (format === void 0) { format = "full"; }
    var f = exports.accountFormatters[format];
    (0, invariant_1["default"])(f, "missing account formatter=" + format);
    return f(account);
}
exports.formatAccount = formatAccount;
function formatOperation(account) {
    var unitByAccountId = function (id) {
        if (!account)
            return;
        if (account.id === id)
            return account.unit;
        var ta = (account.subAccounts || []).find(function (a) { return a.id === id; });
        if (ta)
            return (0, _1.getAccountUnit)(ta);
    };
    var familyExtra = function (operation, unit) {
        if (!account)
            return "";
        var family = account_1["default"][account.currency.family];
        if (family && family.formatOperationSpecifics) {
            return family.formatOperationSpecifics(operation, unit);
        }
        return "";
    };
    return formatOp(unitByAccountId, familyExtra);
}
exports.formatOperation = formatOperation;
//# sourceMappingURL=formatters.js.map